export const Bio = {
  name: "Shiva Kant Mishra",
  roles: [
    "Front-End Developer",
    "Angular Developer",
    "React.js Developer",
    // "Web Developer",
    "Programmer",
  ],
  description:
    "Frontend Developer with 1.5 years of professional experience in building dynamic and responsive web applications using Angular, JavaScript, TypeScript, and RxJS. Known for quickly adapting to new technologies, enhancing processes, and delivering scalable, high-quality solutions. A proactive team player with strong problem-solving skills, committed to creating efficient and user-focused frontend applications",
    // "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/shivakant1105",
  resume:
    "https://drive.google.com/file/d/1Ul4En7jFuETWoP4_0dxpkC6yBj5Jwwqs/view?usp=drivesdk",
  linkedin: "https://www.linkedin.com/in/shiva1105/",
  twitter: "https://twitter.com/ShivaKant1105",
  insta: "https://www.instagram.com/shiva_kant1105/",
  mail: "mailto:kantshiva1105@gmail.com",
  
  facebook:
    "https://www.facebook.com/people/Shiva-Kant-Mishra/pfbid0htmW9Q4vZYBhtNAJHGYNWbt6eKgEQ535C2ZEFeMfZETCt5dkq3XT4ZBQ4hgEan2Gl/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      // {
      //   name: "Redux",
      //   image:
      //     "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      // },
      {
        name: "Angular",
        image: "https://angular.io/assets/images/logos/angular/angular.svg",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "TypeScript",
        image:
          "https://pbs.twimg.com/profile_images/1648471227416346625/v84A9gXA_400x400.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      // {
      //   name: "Graph Ql",
      //   image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
      // },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      // {
      //   name: "MySQL",
      //   image:
      //     "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      // },
      // {
      //   name: "Postgresql",
      //   image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      // },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },

  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://camo.githubusercontent.com/fbfcb9e3dc648adc93bef37c718db16c52f617ad055a26de6dc3c21865c3321d/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6769742d73636d2f6769742d73636d2d69636f6e2e737667",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Google Cloud",
        image:
          "https://www.vectorlogo.zone/logos/google_cloud/google_cloud-ar21.svg",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://camo.githubusercontent.com/93b32389bf746009ca2370de7fe06c3b5146f4c99d99df65994f9ced0ba41685/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f676574706f73746d616e2f676574706f73746d616e2d69636f6e2e737667",
      },
      {
        name: "Canva",
        image:
          "https://static.canva.com/web/images/12487a1e0770d29351bd4ce4f87ec8fe.svg",
      },
      {
        name: "Figma",
        image:
          "https://camo.githubusercontent.com/ed93c2b000a76ceaad1503e7eb9356591b885227e82a36a005b9d3498b303ba5/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6669676d612f6669676d612d69636f6e2e737667",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://zzv5g12a3unl.cdn.shift8web.com/wp-content/uploads/2022/01/In2IT-Technologies.png",
    role: "Angular Developer",
    company: "In2IT Technologies Pvt. Ltd.",
    date: "April 2024 - Present",
    desc: "Developed an advanced CRM tool for OSS/BSS solutions, enhancing customer data management and supportingdynamic change requests. Integrated CRM with Service Order Management for seamless and accurate order processing. Built dynamic forms, user dashboards with amCharts5, and reusable components using ag-Grid for enhanced functionality and user experience.",
    skills: [
      "Html",
      "Css",
      "JavaScript",
      "BootStrap",
   "Angular"
     
    ],
    doc: "",
  },
  // {
  //   id: 1,
  //   img: "https://media.licdn.com/dms/image/C4E0BAQHMzQxDnJsK5w/company-logo_200_200/0/1630640683883/liangtuang_logo?e=2147483647&v=beta&t=aybuaZnjOw76IC4_EsqEF2I9_bcS-DI1FTMddOdaGsM",
  //   role: "Front-end Developer",
  //   company: "LiangTuang Technologies Pvt Ltd",
  //   date: "Feb 2024 - April 2024",
  //   desc: "Working in crafting responsive and visually appealing web interfaces using HTML, CSS, and Bootstrap.Skilled in leveraging JavaScript to enhance user interactions and create dynamic, engaging websites.",
  //   skills: [
  //     "Html",
  //     "Css",
  //     "JavaScript",
  //     "BootStrap",
  //     "React Js",
  //     "Next Js"
  //   ],
  //   doc: "",
  // },
  {
    id: 1,
    img: "data:image/png;base64,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",
    role: "Front-end Developer",
    company: "Etelligens Technologies Pvt. Ltd.",
    date: "Feb 2023 - April 2024",
    desc: "Working on live project, managing Front-end Part and responsive of website , and optimized performance and collaborated effectively, delivering results in high-pressure tech environments.",
    skills: [
      "Html",
      "Css",
      "JavaScript",
      "TypeScript",
      "Angular",
      "Angular Material",
      "Ngrx",
      "BootStrap",
      "JQuery",
    ],
    doc: "https://drive.google.com/file/d/1Bg_aoxkYFOgp7BkREv-FygWZMyZ8xOlU/view?usp=drivesdk",
  },
  {
    id: 2,
    img: "",
    role: "Frontend Developer Intern",
    company: "Abes Engineering College",
    date: "May 2022 - Aug 2022",
    desc: "Working on the frontend of the web application using ReactJS, Redux, and Material UI.",
    skills: [
      "ReactJS",
      "Redux",
      "NodeJs",
      "Material UI",
      "HTML",
      "CSS",
      "JavaScript",
    ],
    doc: "https://drive.google.com/file/d/1wt8izvUYpIa7IZBjn_9_kB7s75qSDaSZ/view?usp=drivesdk",
  },
];

export const education = [
  {
    id: 0,
    img: "https://abes.ac.in/assets/frontend/img/logo-9.png",
    school: "Abes Engineering College, Ghaziabad",
    date: "Aug 2019 - July 2023",
    grade: "6.78 CGPA",
    desc: "I am graduated a Bachelor's degree in Computer Engineering & Information Technology at Abes Engineering Collge, Ghaziabad. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. I am also a member of the Technical Lead of HUHC, Overall coordinator of Environ Club, Organizing college technical fest.",
    degree:
      "Bachelor of Technology - BTech, Computer Engineering & Information Technology",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSvBxuWrRtnIZGFwB5w1RiflPWIB02mgnBViQ&s",
    school: "Urmila Educational Academy, Basti",
    date: "Apr 2015 - Apr 2017",
    grade: "75%",
    desc: "I completed my class 12 high school education at Urmila Educational Academy, Basti.",
    degree: "UP Board(XII), PCM",
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSvBxuWrRtnIZGFwB5w1RiflPWIB02mgnBViQ&s",
    school: "Urmila Educational Academy, Basti",
    date: "Apr 2013 - Apr 2015",
    grade: "83.13%",
    desc: "I completed my class 10 education at Urmila Educational Academy, Basti.",
    degree: "UP Board(X), Science ",
  },
];

export const projects = [
  {
    id: 10,
    title: "Spike-(Organization-Admin-Panel)",
    date: "Aug 2024 - Oct 2024",
    description:
      " Designed and developed a robust role-based admin panel for organizational management, providing functionality for admin and user roles. Implemented role-based authentication and authorization to ensure secure access for admins and users. Developed modules for managing employees, contacts, blogs, notes, and a taskboard using Angular Integrated SweetAlert (Swal) for intuitive and user-friendly error alerts and notifications, enhancing the user experience.",
    image:
      "https://spike-angular-pro-main.netlify.app/assets/images/landingpage/demos/demo-main.jpg",

    tags: [
      "Html/ScSss",
      "JavaScript",
      "Angular",
      "Bootstrap",
      "TypeScript",
     
    ],
    category: "web app",
    github: "https://github.com/Shivakant1105",
    webapp: "https://spike-admin-panel.netlify.app/",
  },
  {
    id: 9,
    title: "Hauskarma",
    date: "Feb 2023 - Jul 2023",
    description:
      "  Rental Housing platform, leveraging HTML, CSS, and JavaScript to enhance user experience and engagement.Implemented a dual-interface system, catering to both renters and landlords, ensuring seamless interactions and transactions. Utilized responsive design techniques, including Angular and Bootstrap, to create an intuitive, mobile-friendly website for optimal user accessibility.",
    image:
      "https://cdn.dribbble.com/users/5460540/screenshots/17523491/media/9de8dcc01d5923600a45b0c82ec31d84.jpg",

    tags: [
      "Html",
      "Css",
      "JavaScript",
      "Angular",
      "Bootstrap",
      "TypeScript",
      "JQuery",
    ],
    category: "web app",
    github: "https://github.com/Shivakant1105/Hauskarma",
    webapp: "https://hauskarma.netlify.app/",
  },
  // {
  //   id: 5,
  //   title: "Foodiemart",
  //   date: "Jun 2021",
  //   description:
  //     " Aesigned and developed a dynamic and responsive food website using Angular, showcasing a passion for both culinary arts and cutting-edge web development.",
  //   image:
  //     "",
  //   tags: [ "Html", "Css","TypeScript", "Angular" ],
  //   category: "web app",
  //   github: "https://github.com/Shivakant1105/Foodiemart",
  //   webapp: "https://github.com/Shivakant1105/",
  // },

  {
    id: 0,
    title: "Airbnb-Clone",
    date: "Apr 2022 - May 2022",
    description:
      "Created a dynamic vacation rental website similar to Airbnb using React, Firebase for user authentication, and JSON data for property listings. Implemented user registration and login functionalities, enhancing the user experience with seamless access to personalized property searches. Designed the user interface with Tailwind CSS, delivering an attractive and responsive platform for property owners and renters. ",
    image:
      "https://s3-alpha.figma.com/hub/file/1539285463/584b258a-4cf9-4078-a26d-11e491935916-cover.png",
    tags: ["React Js", "Json", "Tailwind", "Firebase", "Redux"],
    category: "web app",
    github: "https://github.com/Shivakant1105/Airbnb-Clone",
    webapp: "https://airbnbclone11.netlify.app/",
    
  },

  {
    id: 4,
    title: "Shopper (E-Commerce)",
    date: "Jul 2021",
    description:
      "E-Commerce Website with React JS Overview This repository contains the source code for an eCommerce website built using React JS. The website offers various features, including displaying trending products, product categories for men, women, and kids, a single product page with detailed information..",
    image:
      "https://i.ytimg.com/vi/jbfuzcrfjqQ/maxresdefault.jpg",
    tags: [ "Html", "Css","JavaScript", "React Js" ],
    category: "web app",
    github: "https://github.com/Shivakant1105/E-Commerce-Shopper",
    webapp: "https://shopper3.netlify.app/",
  },
  
];
export const TimeLineData = [
  { year: 2019, text: "Started my journey" },
  { year: 2020, text: "Worked as a freelance developer" },
  { year: 2022, text: "Founded JavaScript Mastery" },
  { year: 2023, text: "Shared my projects with the world" },
  { year: 2023, text: "Started my own platform" },
];
